import React from "react";
import "./PartnerStatusHeader.scss";

import Logo from "../../componentsAdditional/SVG/Cargon/Logo";
import Lang from "../../componentsLanding/Controls/Lang/Lang";

const PartnerStatusHeader = () => {
  return (
    <header id='PartnerStatusHeader'>
      <div className='wrapper'>
        <div className='PartnerStatusHeaderContainer'>
          <div className='PartnerStatusHeaderContainerLogo'>
            <div>
              <div className='fullLogo'>
                <Logo />
              </div>
            </div>
          </div>
          <Lang />
        </div>
      </div>
    </header>
  );
};

export default PartnerStatusHeader;
